import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
import es from './es';
import fr from './fr';

Vue.use(VueI18n);

const loadLocaleMessages = () => {
    const messages = {
        en: en,
        es: es,
        fr: fr
    };
    return messages;
};

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
});
